import { FormControl, FormGroup, FormRecord, Validators } from '@angular/forms';
import { RubriqueMontantForm } from '@cnaf.usagers.appli/cnaf-commons-dral';

/**
 * Données associées aux ressources
 */
export class RessourcesModel {

    public salaireDefini = false;
    public montantSalaire : number;

    public chomagePreretraitreDefini = false;
    public montantChomagePreretraitre : number;
    
    public retraitrePensionDefini = false;
    public montantRetraitrePension : number;

    public pensionAlimentaireDefini = false;
    public montantPensionAlimentaire : number;

    public revenuIndependentAnneeMoins2Defini = false;
    public montantRevenuIndependentAnneeMoins2 : number;

    public aucunRevenuDefini = false;

    constructor() {}
}

/**
 * Objet qui définit les codes associés aux ressources
 */
export class CodesRessourcesModel {
    aucuneRessource:string;
    salaire:string;
    allocationChomage:string;
    retraitrePensionImposable:string;
    pensionAlimentaireRecue:string;
    revenuTravailleurIndependant:string;
}

/**
 * Elements de configuration pour l'affichage d'une ressource
 */
export class ConfigurationRessourceModel {
    code: string;
    libelle: string;
    validators: Array<Validators>;
    placeHolder: string;
}

export class RessourcesForm {
    aucunRevenu : FormControl<boolean>;
    rubriquesMontantRecord : FormRecord<FormGroup<RubriqueMontantForm>>;
}
